/**
 * Info about a user (e.g., uploaders/contributors)
 */
export type UserDetails = {
  screen_name?: string;
  useritem?: string;
  is_archivist?: boolean;
};
